export const cp0 = [121.221457, 31.05697]
export const cp1 = [121.221521, 31.049384]
export const cp2 = [121.211869, 31.059731]

export const line = [
  [121.221457, 31.05697],
  [121.221461, 31.056496],
  [121.221465, 31.056022],
  [121.221469, 31.055548],
  [121.221473, 31.055073],
  [121.221477, 31.054599],
  [121.221481, 31.054125],
  [121.221485, 31.053651],
  [121.221489, 31.053177],
  [121.221493, 31.052703],
  [121.221497, 31.052229],
  [121.221501, 31.051754],
  [121.221505, 31.05128],
  [121.221509, 31.050806],
  [121.221513, 31.050332],
  [121.221517, 31.049858],
  [121.221521, 31.049384],
  [121.221517, 31.049858],
  [121.221513, 31.050332],
  [121.221509, 31.050806],
  [121.221505, 31.05128],
  [121.221501, 31.051754],
  [121.221497, 31.052229],
  [121.221493, 31.052703],
  [121.221489, 31.053177],
  [121.221485, 31.053651],
  [121.221481, 31.054125],
  [121.221477, 31.054599],
  [121.221473, 31.055073],
  [121.221469, 31.055548],
  [121.221465, 31.056022],
  [121.221461, 31.056496],
  [121.221457, 31.05697],
  [121.221456, 31.05714],
  [121.221456, 31.057309],
  [121.221455, 31.057479],
  [121.221455, 31.057648],
  [121.221454, 31.057818],
  [121.221454, 31.057987],
  [121.221453, 31.058157],
  [121.221453, 31.058327],
  [121.221452, 31.058496],
  [121.221452, 31.058666],
  [121.221451, 31.058835],
  [121.22145, 31.059005],
  [121.22145, 31.059174],
  [121.221449, 31.059344],
  [121.221449, 31.059514],
  [121.221448, 31.059683],
  [121.221149, 31.059685],
  [121.22085, 31.059686],
  [121.22055, 31.059688],
  [121.220251, 31.059689],
  [121.219952, 31.059691],
  [121.219652, 31.059692],
  [121.219353, 31.059694],
  [121.219054, 31.059695],
  [121.218754, 31.059697],
  [121.218455, 31.059698],
  [121.218156, 31.0597],
  [121.217856, 31.059701],
  [121.217557, 31.059703],
  [121.217258, 31.059704],
  [121.216958, 31.059706],
  [121.216659, 31.059707],
  [121.21636, 31.059709],
  [121.21606, 31.05971],
  [121.215761, 31.059712],
  [121.215462, 31.059713],
  [121.215162, 31.059715],
  [121.214863, 31.059716],
  [121.214563, 31.059718],
  [121.214264, 31.059719],
  [121.213965, 31.059721],
  [121.213665, 31.059722],
  [121.213366, 31.059724],
  [121.213067, 31.059725],
  [121.212767, 31.059727],
  [121.212468, 31.059728],
  [121.212169, 31.05973],
  [121.211869, 31.059731],
  [121.212169, 31.05973],
  [121.212468, 31.059728],
  [121.212767, 31.059727],
  [121.213067, 31.059725],
  [121.213366, 31.059724],
  [121.213665, 31.059722],
  [121.213965, 31.059721],
  [121.214264, 31.059719],
  [121.214563, 31.059718],
  [121.214863, 31.059716],
  [121.215162, 31.059715],
  [121.215462, 31.059713],
  [121.215761, 31.059712],
  [121.21606, 31.05971],
  [121.21636, 31.059709],
  [121.216659, 31.059707],
  [121.216958, 31.059706],
  [121.217258, 31.059704],
  [121.217557, 31.059703],
  [121.217856, 31.059701],
  [121.218156, 31.0597],
  [121.218455, 31.059698],
  [121.218754, 31.059697],
  [121.219054, 31.059695],
  [121.219353, 31.059694],
  [121.219652, 31.059692],
  [121.219952, 31.059691],
  [121.220251, 31.059689],
  [121.22055, 31.059688],
  [121.22085, 31.059686],
  [121.221149, 31.059685],
  [121.221448, 31.059683],
  [121.221449, 31.059514],
  [121.221449, 31.059344],
  [121.22145, 31.059174],
  [121.22145, 31.059005],
  [121.221451, 31.058835],
  [121.221452, 31.058666],
  [121.221452, 31.058496],
  [121.221453, 31.058327],
  [121.221453, 31.058157],
  [121.221454, 31.057987],
  [121.221454, 31.057818],
  [121.221455, 31.057648],
  [121.221455, 31.057479],
  [121.221456, 31.057309],
  [121.221456, 31.05714],
  [121.221457, 31.05697],
]

export const linex = {
  line1: [
    {
      left_line: [
        [121.221457, 31.05697],
        [121.221461, 31.056496],
        [121.221465, 31.056022],
        [121.221469, 31.055548],
        [121.221473, 31.055073],
        [121.221477, 31.054599],
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221457, 31.05697],
      distance: 0,
    },
    {
      left_line: [
        [121.221461, 31.056496],
        [121.221465, 31.056022],
        [121.221469, 31.055548],
        [121.221473, 31.055073],
        [121.221477, 31.054599],
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221461, 31.056496],
      distance: 52.76678933403302,
    },
    {
      left_line: [
        [121.221465, 31.056022],
        [121.221469, 31.055548],
        [121.221473, 31.055073],
        [121.221477, 31.054599],
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221465, 31.056022],
      distance: 105.53357868183512,
    },
    {
      left_line: [
        [121.221469, 31.055548],
        [121.221473, 31.055073],
        [121.221477, 31.054599],
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221469, 31.055548],
      distance: 158.3003680434062,
    },
    {
      left_line: [
        [121.221473, 31.055073],
        [121.221477, 31.054599],
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221473, 31.055073],
      distance: 211.1784818147319,
    },
    {
      left_line: [
        [121.221477, 31.054599],
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221477, 31.054599],
      distance: 263.94527120386954,
    },
    {
      left_line: [
        [121.221481, 31.054125],
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221481, 31.054125],
      distance: 316.7120606067758,
    },
    {
      left_line: [
        [121.221485, 31.053651],
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221485, 31.053651],
      distance: 369.47885002345055,
    },
    {
      left_line: [
        [121.221489, 31.053177],
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221489, 31.053177],
      distance: 422.24563945389366,
    },
    {
      left_line: [
        [121.221493, 31.052703],
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221493, 31.052703],
      distance: 475.012428898105,
    },
    {
      left_line: [
        [121.221497, 31.052229],
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221497, 31.052229],
      distance: 527.7792183560844,
    },
    {
      left_line: [
        [121.221501, 31.051754],
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221501, 31.051754],
      distance: 580.6573322236146,
    },
    {
      left_line: [
        [121.221505, 31.05128],
        [121.221509, 31.050806],
        [121.221513, 31.050332],
        [121.221517, 31.049858],
        [121.221521, 31.049384],
      ],
      point: [121.221505, 31.05128],
      distance: 633.424121709159,
    },
    {
      left_line: [[121.221509, 31.050806], [121.221513, 31.050332], [121.221517, 31.049858], [121.221521, 31.049384]],
      point: [121.221509, 31.050806],
      distance: 686.1909112084711,
    },
    {
      left_line: [[121.221513, 31.050332], [121.221517, 31.049858], [121.221521, 31.049384]],
      point: [121.221513, 31.050332],
      distance: 738.9577007215509,
    },
    { left_line: [[121.221517, 31.049858], [121.221521, 31.049384]], point: [121.221517, 31.049858], distance: 791.7244902483981 },
    { left_line: [[121.221521, 31.049384]], point: [121.221521, 31.049384], distance: 844.4912797890127 },
  ],
  line2: [
    {
      left_line: [
        [121.221521, 31.049384],
        [121.221517, 31.049858],
        [121.221513, 31.050332],
        [121.221509, 31.050806],
        [121.221505, 31.05128],
        [121.221501, 31.051754],
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221521, 31.049384],
      distance: 0,
    },
    {
      left_line: [
        [121.221517, 31.049858],
        [121.221513, 31.050332],
        [121.221509, 31.050806],
        [121.221505, 31.05128],
        [121.221501, 31.051754],
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221517, 31.049858],
      distance: 52.76678954061463,
    },
    {
      left_line: [
        [121.221513, 31.050332],
        [121.221509, 31.050806],
        [121.221505, 31.05128],
        [121.221501, 31.051754],
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221513, 31.050332],
      distance: 105.53357906746187,
    },
    {
      left_line: [
        [121.221509, 31.050806],
        [121.221505, 31.05128],
        [121.221501, 31.051754],
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221509, 31.050806],
      distance: 158.3003685805416,
    },
    {
      left_line: [
        [121.221505, 31.05128],
        [121.221501, 31.051754],
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221505, 31.05128],
      distance: 211.0671580798537,
    },
    {
      left_line: [
        [121.221501, 31.051754],
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221501, 31.051754],
      distance: 263.83394756539803,
    },
    {
      left_line: [
        [121.221497, 31.052229],
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221497, 31.052229],
      distance: 316.7120614329283,
    },
    {
      left_line: [
        [121.221493, 31.052703],
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221493, 31.052703],
      distance: 369.4788508909077,
    },
    {
      left_line: [
        [121.221489, 31.053177],
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221489, 31.053177],
      distance: 422.24564033511905,
    },
    {
      left_line: [
        [121.221485, 31.053651],
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221485, 31.053651],
      distance: 475.01242976556216,
    },
    {
      left_line: [
        [121.221481, 31.054125],
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221481, 31.054125],
      distance: 527.7792191822368,
    },
    {
      left_line: [
        [121.221477, 31.054599],
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221477, 31.054599],
      distance: 580.5460085851431,
    },
    {
      left_line: [
        [121.221473, 31.055073],
        [121.221469, 31.055548],
        [121.221465, 31.056022],
        [121.221461, 31.056496],
        [121.221457, 31.05697],
      ],
      point: [121.221473, 31.055073],
      distance: 633.3127979742808,
    },
    {
      left_line: [[121.221469, 31.055548], [121.221465, 31.056022], [121.221461, 31.056496], [121.221457, 31.05697]],
      point: [121.221469, 31.055548],
      distance: 686.1909117456065,
    },
    {
      left_line: [[121.221465, 31.056022], [121.221461, 31.056496], [121.221457, 31.05697]],
      point: [121.221465, 31.056022],
      distance: 738.9577011071776,
    },
    { left_line: [[121.221461, 31.056496], [121.221457, 31.05697]], point: [121.221461, 31.056496], distance: 791.7244904549798 },
    { left_line: [[121.221457, 31.05697]], point: [121.221457, 31.05697], distance: 844.4912797890128 },
  ],
  line3: [
    {
      left_line: [
        [121.221457, 31.05697],
        [121.221456, 31.05714],
        [121.221456, 31.057309],
        [121.221455, 31.057479],
        [121.221455, 31.057648],
        [121.221454, 31.057818],
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221457, 31.05697],
      distance: 0,
    },
    {
      left_line: [
        [121.221456, 31.05714],
        [121.221456, 31.057309],
        [121.221455, 31.057479],
        [121.221455, 31.057648],
        [121.221454, 31.057818],
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221456, 31.05714],
      distance: 18.924444529045182,
    },
    {
      left_line: [
        [121.221456, 31.057309],
        [121.221455, 31.057479],
        [121.221455, 31.057648],
        [121.221454, 31.057818],
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221456, 31.057309],
      distance: 37.73740991214165,
    },
    {
      left_line: [
        [121.221455, 31.057479],
        [121.221455, 31.057648],
        [121.221454, 31.057818],
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221455, 31.057479],
      distance: 56.661854439938736,
    },
    {
      left_line: [
        [121.221455, 31.057648],
        [121.221454, 31.057818],
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221455, 31.057648],
      distance: 75.4748198230352,
    },
    {
      left_line: [
        [121.221454, 31.057818],
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221454, 31.057818],
      distance: 94.3992643495842,
    },
    {
      left_line: [
        [121.221454, 31.057987],
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221454, 31.057987],
      distance: 113.21222973268067,
    },
    {
      left_line: [
        [121.221453, 31.058157],
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221453, 31.058157],
      distance: 132.13667425798155,
    },
    {
      left_line: [
        [121.221453, 31.058327],
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221453, 31.058327],
      distance: 151.0609436460845,
    },
    {
      left_line: [
        [121.221452, 31.058496],
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221452, 31.058496],
      distance: 169.87408520128406,
    },
    {
      left_line: [
        [121.221452, 31.058666],
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221452, 31.058666],
      distance: 188.798354589387,
    },
    {
      left_line: [
        [121.221451, 31.058835],
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221451, 31.058835],
      distance: 207.61149614333107,
    },
    {
      left_line: [
        [121.22145, 31.059005],
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.22145, 31.059005],
      distance: 226.5359406655098,
    },
    {
      left_line: [
        [121.22145, 31.059174],
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.22145, 31.059174],
      distance: 245.34890604860627,
    },
    {
      left_line: [
        [121.221449, 31.059344],
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221449, 31.059344],
      distance: 264.2733505695369,
    },
    {
      left_line: [
        [121.221449, 31.059514],
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221449, 31.059514],
      distance: 283.19761995763986,
    },
    {
      left_line: [
        [121.221448, 31.059683],
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221448, 31.059683],
      distance: 302.01076150844324,
    },
    {
      left_line: [
        [121.221149, 31.059685],
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.221149, 31.059685],
      distance: 330.52409090834993,
    },
    {
      left_line: [
        [121.22085, 31.059686],
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.22085, 31.059686],
      distance: 359.0367862592185,
    },
    {
      left_line: [
        [121.22055, 31.059688],
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.22055, 31.059688],
      distance: 387.64550037133677,
    },
    {
      left_line: [
        [121.220251, 31.059689],
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.220251, 31.059689],
      distance: 416.1581948230597,
    },
    {
      left_line: [
        [121.219952, 31.059691],
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.219952, 31.059691],
      distance: 444.67152242471514,
    },
    {
      left_line: [
        [121.219652, 31.059692],
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.219652, 31.059692],
      distance: 473.2796036966769,
    },
    {
      left_line: [
        [121.219353, 31.059694],
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.219353, 31.059694],
      distance: 501.7929303992065,
    },
    {
      left_line: [
        [121.219054, 31.059695],
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.219054, 31.059695],
      distance: 530.305623052638,
    },
    {
      left_line: [
        [121.218754, 31.059697],
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.218754, 31.059697],
      distance: 558.9143344583545,
    },
    {
      left_line: [
        [121.218455, 31.059698],
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.218455, 31.059698],
      distance: 587.42702621264,
    },
    {
      left_line: [
        [121.218156, 31.0597],
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.218156, 31.0597],
      distance: 615.940351116918,
    },
    {
      left_line: [
        [121.217856, 31.059701],
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.217856, 31.059701],
      distance: 644.5484296824179,
    },
    {
      left_line: [
        [121.217557, 31.059703],
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.217557, 31.059703],
      distance: 673.0617536875699,
    },
    {
      left_line: [
        [121.217258, 31.059704],
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.217258, 31.059704],
      distance: 701.5744436435635,
    },
    {
      left_line: [
        [121.216958, 31.059706],
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.216958, 31.059706],
      distance: 730.1831523428775,
    },
    {
      left_line: [
        [121.216659, 31.059707],
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.216659, 31.059707],
      distance: 758.695841399725,
    },
    {
      left_line: [
        [121.21636, 31.059709],
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.21636, 31.059709],
      distance: 787.2091636066248,
    },
    {
      left_line: [
        [121.21606, 31.05971],
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.21606, 31.05971],
      distance: 815.817239465662,
    },
    {
      left_line: [
        [121.215761, 31.059712],
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.215761, 31.059712],
      distance: 844.3305607734355,
    },
    {
      left_line: [
        [121.215462, 31.059713],
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.215462, 31.059713],
      distance: 872.8432480319907,
    },
    {
      left_line: [
        [121.215162, 31.059715],
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.215162, 31.059715],
      distance: 901.4519540249015,
    },
    {
      left_line: [
        [121.214863, 31.059716],
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.214863, 31.059716],
      distance: 929.9646403843103,
    },
    {
      left_line: [
        [121.214563, 31.059718],
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.214563, 31.059718],
      distance: 958.5733454750865,
    },
    {
      left_line: [
        [121.214264, 31.059719],
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.214264, 31.059719],
      distance: 987.086030935349,
    },
    {
      left_line: [
        [121.213965, 31.059721],
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.213965, 31.059721],
      distance: 1015.5993495457433,
    },
    {
      left_line: [
        [121.213665, 31.059722],
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.213665, 31.059722],
      distance: 1044.2074217961626,
    },
    {
      left_line: [
        [121.213366, 31.059724],
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.213366, 31.059724],
      distance: 1072.7207395074304,
    },
    {
      left_line: [
        [121.213067, 31.059725],
        [121.212767, 31.059727],
        [121.212468, 31.059728],
        [121.212169, 31.05973],
        [121.211869, 31.059731],
      ],
      point: [121.213067, 31.059725],
      distance: 1101.2334231693999,
    },
    {
      left_line: [[121.212767, 31.059727], [121.212468, 31.059728], [121.212169, 31.05973], [121.211869, 31.059731]],
      point: [121.212767, 31.059727],
      distance: 1129.842125553772,
    },
    {
      left_line: [[121.212468, 31.059728], [121.212169, 31.05973], [121.211869, 31.059731]],
      point: [121.212468, 31.059728],
      distance: 1158.3548083165947,
    },
    { left_line: [[121.212169, 31.05973], [121.211869, 31.059731]], point: [121.212169, 31.05973], distance: 1186.8681242296093 },
    { left_line: [[121.211869, 31.059731]], point: [121.211869, 31.059731], distance: 1215.4761937735643 },
  ],
  line4: [
    {
      left_line: [
        [121.211869, 31.059731],
        [121.212169, 31.05973],
        [121.212468, 31.059728],
        [121.212767, 31.059727],
        [121.213067, 31.059725],
        [121.213366, 31.059724],
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.211869, 31.059731],
      distance: 0,
    },
    {
      left_line: [
        [121.212169, 31.05973],
        [121.212468, 31.059728],
        [121.212767, 31.059727],
        [121.213067, 31.059725],
        [121.213366, 31.059724],
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.212169, 31.05973],
      distance: 28.608069543955125,
    },
    {
      left_line: [
        [121.212468, 31.059728],
        [121.212767, 31.059727],
        [121.213067, 31.059725],
        [121.213366, 31.059724],
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.212468, 31.059728],
      distance: 57.121385456969634,
    },
    {
      left_line: [
        [121.212767, 31.059727],
        [121.213067, 31.059725],
        [121.213366, 31.059724],
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.212767, 31.059727],
      distance: 85.63406821979243,
    },
    {
      left_line: [
        [121.213067, 31.059725],
        [121.213366, 31.059724],
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.213067, 31.059725],
      distance: 114.24277060416449,
    },
    {
      left_line: [
        [121.213366, 31.059724],
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.213366, 31.059724],
      distance: 142.7554542661339,
    },
    {
      left_line: [
        [121.213665, 31.059722],
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.213665, 31.059722],
      distance: 171.2687719774017,
    },
    {
      left_line: [
        [121.213965, 31.059721],
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.213965, 31.059721],
      distance: 199.8768442278211,
    },
    {
      left_line: [
        [121.214264, 31.059719],
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.214264, 31.059719],
      distance: 228.39016283821545,
    },
    {
      left_line: [
        [121.214563, 31.059718],
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.214563, 31.059718],
      distance: 256.9028482984779,
    },
    {
      left_line: [
        [121.214863, 31.059716],
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.214863, 31.059716],
      distance: 285.5115533892541,
    },
    {
      left_line: [
        [121.215162, 31.059715],
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.215162, 31.059715],
      distance: 314.024239748663,
    },
    {
      left_line: [
        [121.215462, 31.059713],
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.215462, 31.059713],
      distance: 342.63294574157374,
    },
    {
      left_line: [
        [121.215761, 31.059712],
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.215761, 31.059712],
      distance: 371.1456330001289,
    },
    {
      left_line: [
        [121.21606, 31.05971],
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.21606, 31.05971],
      distance: 399.6589543079024,
    },
    {
      left_line: [
        [121.21636, 31.059709],
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.21636, 31.059709],
      distance: 428.26703016693966,
    },
    {
      left_line: [
        [121.216659, 31.059707],
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.216659, 31.059707],
      distance: 456.7803523738394,
    },
    {
      left_line: [
        [121.216958, 31.059706],
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.216958, 31.059706],
      distance: 485.29304143068697,
    },
    {
      left_line: [
        [121.217258, 31.059704],
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.217258, 31.059704],
      distance: 513.901750130001,
    },
    {
      left_line: [
        [121.217557, 31.059703],
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.217557, 31.059703],
      distance: 542.4144400859947,
    },
    {
      left_line: [
        [121.217856, 31.059701],
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.217856, 31.059701],
      distance: 570.9277640911466,
    },
    {
      left_line: [
        [121.218156, 31.0597],
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.218156, 31.0597],
      distance: 599.5358426566465,
    },
    {
      left_line: [
        [121.218455, 31.059698],
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.218455, 31.059698],
      distance: 628.0491675609245,
    },
    {
      left_line: [
        [121.218754, 31.059697],
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.218754, 31.059697],
      distance: 656.5618593152101,
    },
    {
      left_line: [
        [121.219054, 31.059695],
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.219054, 31.059695],
      distance: 685.1705707209265,
    },
    {
      left_line: [
        [121.219353, 31.059694],
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.219353, 31.059694],
      distance: 713.683263374358,
    },
    {
      left_line: [
        [121.219652, 31.059692],
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.219652, 31.059692],
      distance: 742.1965900768877,
    },
    {
      left_line: [
        [121.219952, 31.059691],
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.219952, 31.059691],
      distance: 770.8046713488494,
    },
    {
      left_line: [
        [121.220251, 31.059689],
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.220251, 31.059689],
      distance: 799.3179989505048,
    },
    {
      left_line: [
        [121.22055, 31.059688],
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.22055, 31.059688],
      distance: 827.8306934022278,
    },
    {
      left_line: [
        [121.22085, 31.059686],
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.22085, 31.059686],
      distance: 856.439407514346,
    },
    {
      left_line: [
        [121.221149, 31.059685],
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221149, 31.059685],
      distance: 884.9521028652146,
    },
    {
      left_line: [
        [121.221448, 31.059683],
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221448, 31.059683],
      distance: 913.4654322651212,
    },
    {
      left_line: [
        [121.221449, 31.059514],
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221449, 31.059514],
      distance: 932.2785738159246,
    },
    {
      left_line: [
        [121.221449, 31.059344],
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221449, 31.059344],
      distance: 951.2028432040275,
    },
    {
      left_line: [
        [121.22145, 31.059174],
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.22145, 31.059174],
      distance: 970.1272877249581,
    },
    {
      left_line: [
        [121.22145, 31.059005],
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.22145, 31.059005],
      distance: 988.9402531080545,
    },
    {
      left_line: [
        [121.221451, 31.058835],
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221451, 31.058835],
      distance: 1007.8646976302333,
    },
    {
      left_line: [
        [121.221452, 31.058666],
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221452, 31.058666],
      distance: 1026.6778391841774,
    },
    {
      left_line: [
        [121.221452, 31.058496],
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221452, 31.058496],
      distance: 1045.6021085722803,
    },
    {
      left_line: [
        [121.221453, 31.058327],
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221453, 31.058327],
      distance: 1064.4152501274798,
    },
    {
      left_line: [
        [121.221453, 31.058157],
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221453, 31.058157],
      distance: 1083.3395195155827,
    },
    {
      left_line: [
        [121.221454, 31.057987],
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221454, 31.057987],
      distance: 1102.2639640408836,
    },
    {
      left_line: [
        [121.221454, 31.057818],
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221454, 31.057818],
      distance: 1121.0769294239801,
    },
    {
      left_line: [
        [121.221455, 31.057648],
        [121.221455, 31.057479],
        [121.221456, 31.057309],
        [121.221456, 31.05714],
        [121.221457, 31.05697],
      ],
      point: [121.221455, 31.057648],
      distance: 1140.0013739505291,
    },
    {
      left_line: [[121.221455, 31.057479], [121.221456, 31.057309], [121.221456, 31.05714], [121.221457, 31.05697]],
      point: [121.221455, 31.057479],
      distance: 1158.8143393336256,
    },
    {
      left_line: [[121.221456, 31.057309], [121.221456, 31.05714], [121.221457, 31.05697]],
      point: [121.221456, 31.057309],
      distance: 1177.7387838614227,
    },
    { left_line: [[121.221456, 31.05714], [121.221457, 31.05697]], point: [121.221456, 31.05714], distance: 1196.5517492445192 },
    { left_line: [[121.221457, 31.05697]], point: [121.221457, 31.05697], distance: 1215.4761937735643 },
  ],
}
